import { render, staticRenderFns } from "./PickType.vue?vue&type=template&id=2ae62033&scoped=true&"
import script from "./PickType.vue?vue&type=script&lang=js&"
export * from "./PickType.vue?vue&type=script&lang=js&"
import style0 from "./PickType.vue?vue&type=style&index=0&id=2ae62033&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae62033",
  null
  
)

export default component.exports